/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerAzureOpenAiAssistant
 */
export interface SingleTurnChatInferencerAzureOpenAiAssistant {
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistant
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistant
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistant
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistant
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistant
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistant
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistant
   */
  assistantId: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistant
   */
  assistantEndpoint: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAzureOpenAiAssistant
   */
  assistantApiVersion: string;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerAzureOpenAiAssistant interface.
 */
export function instanceOfSingleTurnChatInferencerAzureOpenAiAssistant(
  value: object,
): value is SingleTurnChatInferencerAzureOpenAiAssistant {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  if (!('assistantEndpoint' in value) || value['assistantEndpoint'] === undefined) return false;
  if (!('assistantApiVersion' in value) || value['assistantApiVersion'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerAzureOpenAiAssistantFromJSON(
  json: any,
): SingleTurnChatInferencerAzureOpenAiAssistant {
  return SingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerAzureOpenAiAssistant {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
    assistantEndpoint: json['assistant_endpoint'],
    assistantApiVersion: json['assistant_api_version'],
  };
}

export function SingleTurnChatInferencerAzureOpenAiAssistantToJSON(
  value?: Omit<SingleTurnChatInferencerAzureOpenAiAssistant, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
    assistant_endpoint: value['assistantEndpoint'],
    assistant_api_version: value['assistantApiVersion'],
  };
}
